import React from 'react';
import Datetime from 'react-datetime';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import { Field } from 'formik';
import { get } from 'lodash';
import moment from 'moment';
import {
  DATE_FORMAT,
  dateToString,
  REVERSE_DASH_DATE_FORMAT,
} from '../../utils/date/Date.utils';
import '../../../assets/css/componentStyles/FormInputField.css';

// Set Monday as the first day of the week globally for moment (affects react-datetime)
moment.updateLocale('en', { week: { dow: 1 } });

function FormDatePickerFieldInner(props) {
  const {
    label,
    placeholder,
    form,
    field,
    onChangeHandler,
    disabled,
    isUpperRange,
    readOnly,
    format = (value) => dateToString(value),
    timeFormat,
    dateFormat,
    labelVariant,
    icon,
    iconClassName,
    required,
    closeBtn,
  } = props;

  const error = form.errors[field.name];
  const touched = form.touched[field.name];
  const value = form.values[field.name] || get(form.values, field.name, '') || '';

  const isBordered = labelVariant === 'bordered';
  const labelClassName = isBordered
    ? `form-input-field-label ${required ? 'label-required' : ''} ${
        disabled ? 'form-input-field-label__disabled' : ''
      }`.trim()
    : '';
  const formGroupClassName = isBordered ? 'form-group--bordered-label' : '';

  return (
    <Row>
      <Col style={{ textAlign: 'left' }}>
        <FormGroup className={formGroupClassName}>
          <Label className={labelClassName}>{label}</Label>
          <div className={icon ? 'icon-form-input-field-wrapper' : ''}>
            {icon && !value && (
              <div
                className={`input-icon ${iconClassName || 'icon-form-input-field-image-wrapper'} ${
                  disabled ? 'input-icon__disabled' : ''
                }`}
              >
                <img src={icon} alt="Input icon" />
              </div>
            )}
            {value && !disabled && !readOnly && closeBtn && (
              <div
                className={`input-icon ${iconClassName || 'icon-form-input-field-image-wrapper'} ${
                  disabled ? 'input-icon__disabled' : ''
                }`}
                style={{ cursor: 'pointer' }}
                role="button"
                tabIndex={0}
                aria-label="Clear date"
                onClick={() => {
                  form.setFieldValue(field.name, null);
                  form.setFieldTouched(field.name, false);
                  if (onChangeHandler) {
                    onChangeHandler(null);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    form.setFieldValue(field.name, null);
                    form.setFieldTouched(field.name, false);
                    if (onChangeHandler) {
                      onChangeHandler(null);
                    }
                  }
                }}
              >
                <span style={{ fontSize: '14px', color: '#666' }}>✕</span>
              </div>
            )}
            <Datetime
              key={`datetime-${field.name}-${value || 'empty'}`}
              closeOnSelect={true}
              timeFormat={timeFormat}
              dateFormat={dateFormat}
              inputProps={{
                readOnly,
                placeholder,
                disabled: form.isSubmitting || disabled,
                className: `form-control ${readOnly ? 'form-control--read-only' : ''} ${icon ? 'icon-form-input-field' : ''}`,
              }}
              value={value ? format(value) : ''}
              onBlur={() => form.setFieldTouched(field.name, true)}
              onChange={(option) => {
                if (isUpperRange) {
                  option.add(1, 'd');
                  option.subtract(1, 'ms');
                }
                form.setFieldValue(
                  field.name,
                  moment(option).format(REVERSE_DASH_DATE_FORMAT),
                );
                onChangeHandler(option);
              }}
            />
          </div>
          {(form.submitCount > 0 || touched) && error && (
            <label style={{ color: 'red ' }}>{error}</label>
          )}
        </FormGroup>
      </Col>
    </Row>
  );
}

function FormDatePickerField({
  placeholder = '',
  options = [],
  onChangeHandler = () => {},
  disabled = false,
  label = '',
  isUpperRange = false,
  readOnly = false,
  timeFormat = false,
  dateFormat = DATE_FORMAT,
  format = (value) => dateToString(value),
  labelVariant = '',
  icon = '',
  iconClassName = '',
  required = false,
  closeBtn = false,
  ...rest
}) {
  return (
    <Field
      placeholder={placeholder}
      options={options}
      onChangeHandler={onChangeHandler}
      disabled={disabled}
      label={label}
      isUpperRange={isUpperRange}
      readOnly={readOnly}
      timeFormat={timeFormat}
      dateFormat={dateFormat}
      format={format}
      icon={icon}
      iconClassName={iconClassName}
      required={required}
      closeBtn={closeBtn}
      {...rest}
      labelVariant={labelVariant}
      component={FormDatePickerFieldInner}
    />
  );
}

export default FormDatePickerField;
